module.exports = __webpack_public_path__ + "img/center front length.f80c3504.png";